import { Box, Link, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { zoullooColors } from "../../../theme";

const FreelancerOnboardingApplicationMessage: React.FC = () => {
	const { t } = useTranslation();

	return (
		<Box>
			<Typography variant="h2" gutterBottom>
				{t("freelancerApplication.title")}
			</Typography>

			<Typography variant="body1" lineHeight={3.5}>
				{t("freelancerApplication.thankYouMessage")}
			</Typography>

			<Typography variant="body1" lineHeight={3.5}>
				{t("freelancerApplication.appointmentMessage")}
			</Typography>

			{/* Contact Information */}
			<Typography variant="body1" lineHeight={3.5}>
				{t("freelancerApplication.contactMessage")}{" "}
				<Link
					href="mailto:hello_talent@zoulloo.com"
					sx={{
						color: zoullooColors.secondary.main,
						fontWeight: "500",
						textDecoration: "none",
						cursor: "pointer",
						"&:hover": {
							textDecoration: "underline"
						}
					}}
				>
					hello_talent@zoulloo.com
				</Link>
			</Typography>

			<Typography variant="body1" lineHeight={3.5}>
				{t("freelancerApplication.followUpMessage")}
			</Typography>

			<Typography variant="body1" lineHeight={3.5}>
				{t("freelancerApplication.closingMessage")}
			</Typography>

			<Typography variant="body1" lineHeight={3.5}>
				{t("freelancerApplication.signature")}
			</Typography>
		</Box>
	);
};

export default FreelancerOnboardingApplicationMessage;
